<template>
  <div v-loading="loading">       
      <v-chart :option="dialogData.ntuChart" style="width:100%;height:300%;" autoresize />    
      <v-chart :option="dialogData.ppmChart" style="width:100%;height:300%" autoresize />
      <v-chart :option="dialogData.phChart" style="width:100%;height:300%" autoresize />    
  </div>
</template>

<script>

export default {
  // 用水狀況-水質詳細資料
  name: 'QualityDetail',
  data() {
    return {
      qualityId:undefined,
      loading: false,
      dialogData: {                            
        ntuChart: {
          title: {
            text: "濁度",
          }, 
          series:[
            {
              type: 'gauge',
              min:0,
              max:3,
              splitNumber:3,
              axisLine: {
                lineStyle: {
                  color: [
                    [0.6667, '#8CC933'],
                    [1, '#FA9732']
                  ]
                }
              },
              anchor: {
                show: true,
                showAbove: true,
                size: 10,
                itemStyle: {
                  color: '#000'
                }
              },
              pointer: {
                width: 3,
                itemStyle: {
                  color: '#000'
                }
              },
              axisLabel: {
                formatter: function (value) {
                  return value.toFixed(2);
                }
              },
              data: [
                {
                  value: 100,
                  detail: {
                    fontSize: 14,
                    offsetCenter: ['0%', '80%'],
                    color: 'inherit',
                    formatter: (value) => value.toFixed(2) + ' NTU'
                  },
                }
              ]
            },
          ]
        },
        ppmChart: {
          title: {
            text: "餘氯",
          }, 
          series:[
            {
              type: 'gauge',
              min:0,
              max:1.2,
              splitNumber:6,
              axisLine: {
                lineStyle: {
                  color: [
                    [0.1666, '#FA9732'],
                    [0.8334, '#8CC933'],
                    [1, '#FA9732'],
                  ]
                }
              },
              anchor: {
                show: true,
                showAbove: true,
                size: 10,
                itemStyle: {
                  color: '#000'
                }
              },
              pointer: {
                width: 3,
                itemStyle: {
                  color: '#000'
                }
              },
              axisLabel: {
                formatter: function (value) {
                  return value.toFixed(2);
                }
              },
              data: [
                {
                  value: 50,
                  detail: {
                    fontSize: 14,
                    offsetCenter: ['0%', '80%'],
                    color: 'inherit',
                    formatter: (value) => value.toFixed(2) + ' ppm'
                  },
                }
              ]
            },
          ]
        },
        phChart: {
          title: {
            text: "酸鹼度",
          }, 
          series:[
            {
              type: 'gauge',
              min:0,
              max:15,
              splitNumber:3,
              axisLine: {
                lineStyle: {
                  color: [
                    [0.3999, '#FA9732'],
                    [0.5667, '#8CC933'],
                    [1, '#FA9732']
                  ]
                }
              },
              anchor: {
                show: true,
                showAbove: true,
                size: 10,
                itemStyle: {
                  color: '#000'
                }
              },
              pointer: {
                width: 3,
                itemStyle: {
                  color: '#000'
                }
              },
              axisLabel: {
                formatter: function (value) {
                  return value.toFixed(2);
                }
              },
              data: [
                {
                  value: 50,
                  detail: {
                    fontSize: 14,
                    offsetCenter: ['0%', '80%'],
                    color: 'inherit',
                    formatter: (value) => 'pH ' + value.toFixed(2)
                  },
                }
              ]
            },
          ]
        },
      },
      abnormalchart: {
        ntuChart: {
          title: {
            text: "濁度",
          }, 
          series:[
            {
              type: 'gauge',
              min:0,
              max:3,
              splitNumber:3,
              axisLine: {
                lineStyle: {
                  color: [
                    [0.6667, '#8CC933'],
                    [1, '#FA9732']
                  ]
                }
              },
              anchor: {
                show:false
              },
              pointer: {
                show:false
              },
              axisLabel: {
                show:false,
                formatter: function (value) {
                  return value.toFixed(2);
                }
              },
              data: [
                {
                  value: 0,
                  name: '維修中，暫停監測',
                  title: {
                    offsetCenter: ['0%', '0%'],
                    fontWeight: 'bold',
                  },
                  detail: {
                    fontSize: 14,
                    color: '#8CC933',
                    offsetCenter: ['0%', '80%'],
                    formatter: 'NA NTU'
                  },
                }
              ]
            },
          ]
        },
        ppmChart: {
          title: {
            text: "餘氯",
          }, 
          series:[
            {
              type: 'gauge',
              min:0,
              max:1.2,
              splitNumber:6,
              axisLine: {
                lineStyle: {
                  color: [
                    [0.1666, '#FA9732'],
                    [0.8334, '#8CC933'],
                    [1, '#FA9732'],
                  ]
                }
              },
              anchor: {
                show:false
              },
              pointer: {
                show:false
              },
              axisLabel: {
                show:false,
                formatter: function (value) {
                  return value.toFixed(2);
                }
              },
              data: [
                {
                  value: 0,
                  name: '維修中，暫停監測',
                  title: {
                    offsetCenter: ['0%', '0%'],
                    fontWeight: 'bold',
                  },
                  detail: {
                    fontSize: 14,
                    color: '#8CC933',
                    offsetCenter: ['0%', '80%'],
                    formatter: 'NA ppm'
                  },
                }
              ]
            },
          ]
        },
        phChart: {
          title: {
            text: "酸鹼度",
          }, 
          series:[
            {
              type: 'gauge',
              min:0,
              max:15,
              splitNumber:3,
              axisLine: {
                lineStyle: {
                  color: [
                    [0.3999, '#FA9732'],
                    [0.5667, '#8CC933'],
                    [1, '#FA9732']
                  ]
                }
              },
              anchor: {
                show:false
              },
              pointer: {
                show:false
              },
              axisLabel: {
                show:false,
                formatter: function (value) {
                  return value.toFixed(2);
                }
              },
              data: [
                {
                  value: 0,
                  name: '維修中，暫停監測',
                  title: {
                    offsetCenter: ['0%', '0%'],
                    fontWeight: 'bold',
                  },
                  detail: {
                    fontSize: 14,
                    color: '#8CC933',
                    offsetCenter: ['0%', '80%'],
                    formatter: 'pH NA'
                  },
                }
              ]
            },
          ]
        },
      },
    };
  },
  async created() {
    this.getQualityData()
  },
  mounted() {
  },
  computed: {
      currentWaterNum() {
        return JSON.parse(localStorage.getItem('currentProfile')).waterNum        
      },
     
  },
  methods: {
    async getQualityData()
    {
      await this.axios.get('/api/system/monitor/waterNum/' + this.currentWaterNum ).then(res => {   
        console.log('res=',res.data.length)  
        if (res.data.length > 0) {          
            let data = res.data
            data.forEach(element => {
              let type = element.type // 紀錄日期格式化
              if (type =='Quality')
                this.qualityId= element.id         
            });
        }
      })
      
      if (this.qualityId){
        this.loading = true
        //let url = "/api/report/monitor/" + item.id + "/rawdata"
        await this.axios.get('/api/report/monitor/' + this.qualityId+"/rawdata" ).then(res => {
          const cntuVal = res.data.data.cntu
          const clVal = res.data.data.cl
          const phVal = res.data.data.ph
          
          if(this.isNormalValue('cntu', cntuVal)) {
            this.dialogData.ntuChart.series[0].data[0].value = cntuVal
          } else {
            this.dialogData.ntuChart = this.abnormalchart.ntuChart
          }
          if(this.isNormalValue('cl', clVal)) {
            this.dialogData.ppmChart.series[0].data[0].value = clVal
          } else {
            this.dialogData.ppmChart = this.abnormalchart.ppmChart
          }
          if(this.isNormalValue('ph', phVal)) {
            this.dialogData.phChart.series[0].data[0].value = phVal
          } else {
            this.dialogData.phChart = this.abnormalchart.phChart
          }
        }).catch(() => {
          this.$message({ message: '無法擷取資料!', type: 'warning' })
        })
        .finally(() => {
          this.loading = false
        })
      }
    },
    // 是否為正常範圍值
    isNormalValue(type, val) {
      let result = false
      switch(type) {
        case 'cntu':
          if(val<= 2) {
            result = true
          }
          break
        case 'cl':
          if(val>= 0.2 && val <= 1) {
            result = true
          }
          break
        case 'ph':
          if(val>= 6 && val <= 8.5) {
            result = true
          }
          break
      }

      return result
    },
  }  
}
</script>